<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">资产维修</h2>
    </div>
    <div class="form-content" style="padding:10px;">
      <!-- 资产维修条目 -->
      <p style="padding: 10px 0 0;color: #d93c37;">已选择变更的资产维修</p>
      <el-table class="table-change-list" :data="assetRepair.data" style="width: 100%">
        <el-table-column prop="number" label="资产编号" width="110px">
        </el-table-column>
        <el-table-column prop="name" label="资产名称">
        </el-table-column>
        <el-table-column prop="attribute.name" label="资产属性" width="90px">
        </el-table-column>
        <el-table-column prop="spec" label="规格型号" width="140px">
        </el-table-column>
        <el-table-column prop="price" label="购置金额" width="75px">
        </el-table-column>
        <el-table-column prop="purchaseTime" label="购置时间" width="110px">
        </el-table-column>
      </el-table>

      <p style="padding: 10px 0 10px;color: #d93c37;">维修信息</p>
      <div style="border:1px #ccc solid;overflow:hidden;">
        <el-col :span="23">
          <div v-if="this.assetRepair.data.length > 1" style="background:#d93c37;color:#fff;margin:20px 0 0 20px;padding:10px 15px;border-radius:5px;">提示：同时编辑多条记录时请只填写需要统一修改的内容</div>
          <el-form ref="form" :model="form" label-width="140px" class="form">
            <asset-repair-form ref="create" :userData="userData" :changeType="assetRepair.type" :formByFather="form"></asset-repair-form>
          </el-form>
        </el-col>
      </div>

      <div class="form-btn-room" style="margin-top:15px;">
        <el-button :loading="formLoading" @click="createAsset()" class="form-btn" type="success">{{formBtnText}}</el-button>
        <el-button @click="$router.back()" type="info" plain>取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  // import Create1 from '../form/create1'
  import AssetRepairForm from './assetRepairForm'
  export default {
    components: {
      AssetRepairForm,
    },
    computed: {
      ...mapState({
        assetRepair: state => state.asset.assetRepair,
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 组织架构
        organizationListData: [],
        // 是否可以切换公司
        noSelectOrganization: true,
        // attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        form: {
          assetIds: "",
          content: "",
          cost: "",
          remark: "",
          repairStatusCode: 0,
          repairTime: "",
          repairerId: "",
        },

        attributeArr: [],

        // loading状态
        formLoading: false,
        formBtnText: '确认提交'
      }
    },
    created() {
      this.form.assetIds = this.assetRepair.data.map(item => item.id).join(",")
      this.getAttribute()
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      // this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      // 维修编辑
      this.form.wxId = this.$route.params.id
      if (this.form.wxId) {
        // 获取原维修单内容
        this.getRepairDetail()
      }
    },
    methods: {
      // 获取资产属性
      getAttribute() {
        ajax.get('/asset/attribute/list', '', (res) => {
          this.attributeArr = res.vo.array
        })
      },
      // 获取维修单详情
      getRepairDetail() {
        ajax.get('/asset/repair/info/' + this.form.wxId, '', (res) => {
          for (var key in res.vo) {
            this.form[key] = res.vo[key]
          }
        })
      },
      // 编辑资产
      createAsset() {
        this.form = this.$refs.create.getFromData()
        this.formLoading = true
        let _url = this.form.wxId ? '/asset/repair/edit' : '/asset/repair/add'
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.$message.success("资产维修单提交成功")
          this.$router.push("/Asset/RepairList")
        })
      },
    },
    watch: {

    },
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/Repair.vue